export default {
    numDisputas(state) {
        return state.disputas.length;
    }
}